// plugins/element-plus.js
import { ElButton, ElTooltip, ElIcon, ElMessage } from 'element-plus'
import 'element-plus/theme-chalk/el-button.css'
import 'element-plus/theme-chalk/el-tooltip.css'
import 'element-plus/theme-chalk/el-icon.css'
import 'element-plus/theme-chalk/el-message.css'
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ElButton)
  nuxtApp.vueApp.use(ElTooltip)
  nuxtApp.vueApp.use(ElIcon)

  // ElMessage 是函数调用，不是组件，所以不需要 use
  nuxtApp.provide('ElMessage', ElMessage)
})
